<div class="c-cms-form">
    <div class="form-flex">
        <div class="form-label">{{if field.required == 1}}<span class="form-required">*</span>{{/if}}{{field.displayName}}</div>
        <div class="form-value">
            <div class="form-row">
                <div class="c-form-select {{field.error.otherValue ? 'open' : ''}}">
                    <div class="select-menu">
                        <div class="select-value">{{field.value[0] || '请选择'}}</div>
                        <div class="select-tips"></div>
                    </div>
                    <div class="select-mask"></div>
                    <ul class="select-main">
                        {{each field.listOptions}}
                        <li onclick="$sk.clickLIST({{$value.optionId}}, '{{field.fieldName}}')" class="{{$value.checked ? 'active' : ''}}">
                            <span class="select-text">
                                {{$value.optionValue}}
                            </span>
                            {{if $value.otherisFillIn == 1}}
                            <input type="text" class="select-other" value="{{$value.otherValue}}"
                                   onclick="$sk.clickListFocus(event, {{`${JSON.stringify($value)}`}}, '{{field.fieldName}}')"
                                   onchange="$sk.changeListOtherValue(this, {{$value.optionId}}, '{{field.fieldName}}')" />
                            {{/if}}
                            {{if $value.checked && $value.dirty && $value.otherisFillIn == 1 && $value.otherIsRequire == 1 && !$value.otherValue}}
                            <div class="form-error">请填写</div>
                            {{/if}}
                        </li>
                        {{/each}}
                    </ul>
                </div>
            </div>
            {{if field.dirty && field.invalid}}
            <div class="form-row form-error">{{field.validationMessage}}</div>
            {{/if}}
        </div>
    </div>
</div>